import gql from 'graphql-tag'
import {IDS} from "../../Constants/IDS";

export const GET_TRIP_COUNT = gql`
    query{
        TripCount: VehicleTrip_aggregate {
            aggregate {
                count
            }
        }
    }`

export const GET_SHOP_LAST_VISITED = gql`
    query ($shopIds:[uuid!],$orgId:uuid!){
        TripDestinations(where: {VehicleTrip: {organizationId: {_eq: $orgId}}, shopId: {_in: $shopIds}}, order_by: {checkInTime: desc_nulls_last}) {
            id
            shopId
            checkInTime
        }
    }`

export const GET_DRIVER_CURRENT_TRIP = gql`
    query($driverId:uuid!){
        VehicleTrip(where: {driverId: {_eq: $driverId}, statusId: {_eq: "${IDS.TripStatus.InProgress}"}}) {
            id            
            driverId
            vehicleId
        }
    }`
export const GET_VEHICLE_CURRENT_TRIP = gql`
    query($vehicleId:uuid!){
        VehicleTrip(where: {vehicleId: {_eq: $vehicleId}, statusId: {_eq: "${IDS.TripStatus.InProgress}"}}) {
            id            
            driverId
            vehicleId
        }
    }`

export const GET_OPENING_TRIP_BY_VEHICLE = gql`
    query($vehicleId:uuid!){
        VehicleTrip(where: {vehicleId: {_eq: $vehicleId}, statusId: {_eq: "${IDS.TripStatus.UnloadedWithOpening}"}},order_by: {updated_at: desc}, limit: 1) {
            id            
            driverId
            vehicleId
            organizationId
            VehicleTripStock{
                id
                productId
                unitId
                initialQty
                currentQty
                unloadedQty
            }
        }
    }`
